import ButtonsFixed from '@ui/buttons/ButtonsFixed'
import Page from '@shell/Page'
import { useOrder } from '@order/hooks/useOrderState'
import { router, useLocalSearchParams } from 'expo-router'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'

import { useSelectPrescription } from '@order/hooks/useSelectPrescription'
import { trpc } from 'api'
import { useCustomer } from 'hooks/useSession'
import { Values } from '@screens/vision/values/Content'

export default function PrescriptionView() {
  const { t } = useTranslation(['ui'])
  const params = useLocalSearchParams<{
    prescriptionId: string
  }>()
  const prescriptionId = Number(params.prescriptionId)
  const customer = useCustomer()

  const { data } = trpc.customer.prescriptions.byId.useQuery(
    {
      prescriptionId: Number(params.prescriptionId) || 0,
      customerId: customer?.id || 0, // TODO: check this param
    },
    {
      enabled: !!prescriptionId && !!customer?.id,
    }
  )

  const selectPrescription = useSelectPrescription()
  const order = useOrder()
  const isActive = order.prescriptionId === data?.id

  if (!data) {
    return null
  }

  return (
    <>
      <Page stage="vision">
        <View className="pt-8" />
        <Values data={data} />
      </Page>
      <ButtonsFixed
        buttons={[
          {
            variant: 'outlined',
            label: t('ui:back'),
            iconStart: 'arrow-narrow-left',
            onPress: () => router.back(),
          },
          {
            disabled: isActive,
            variant: 'filled',
            label: t('ui:activatePrescription'),
            onPress: () => {
              selectPrescription.select(data)
              router.back()
            },
          },
        ]}
      />
    </>
  )
}
